import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/app/dialog/dialog";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Button } from "components/ui/button";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { X } from "lucide-react";

interface DialogProps {
  editItemImageCategories: any;
  isDialogEditImageOpen: boolean;
  setIsDialogEditImageOpen: (value: boolean) => void;
  // updateImage: (newImage: File) => void; // Add this to update the image in parent component
}

export default function DailogEditImageCategories({
  editItemImageCategories,
  isDialogEditImageOpen,
  setIsDialogEditImageOpen,
}: // updateImage, // Add this prop to pass the updated image back to the parent component
DialogProps) {
  const [imagePreview, setImagePreview] = useState<any>(null);
  const handleImageChange = (event: any) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImagePreview(imageUrl);
    }
  };
  useEffect(() => {
    if (editItemImageCategories?.thumbnail) {
      setImagePreview(editItemImageCategories.thumbnail); // Set initial image if available
    }
  }, [editItemImageCategories]);
  return (
    <Dialog open={isDialogEditImageOpen}>
      <DialogContent isShowBtnXClose={false} className="custom-dialog-class flex flex-col justify-between">
        <DialogHeader>
          <DialogTitle> Add New Group </DialogTitle>
          <DialogDescription>Input group description and choose the category, click "Save" when you finished.</DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => {
              setIsDialogEditImageOpen(false);
              setImagePreview(null);
            }}
          >
            <X />
          </div>
        </DialogHeader>
        <ScrollArea className="mt-2 w-full gap-3 h-[300px] pr-[20px]">
          <div className="flex flex-col ">
            {/* Image Preview */}
            <label htmlFor="file-upload" className="cursor-pointer">
              <ImageUrl
                className="w-full h-full rounded-md flex-shrink-0 object-cover"
                src={imagePreview} // Use image preview or fallback to original
                alt="Image preview"
              />
            </label>
            {/* Hidden file input */}
            <input type="file" id="file-upload" className="hidden" onChange={handleImageChange} />
          </div>
          <ScrollBar orientation="vertical" />
        </ScrollArea>
        <DialogFooter>
          <Button className="w-full text-white mt-3 bg-blue-600 hover:bg-blue-500">
            Save
            {/* {loadingSubmit ? <Loader className="animate-spin" /> : "Save"} */}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
